export default __webpack_public_path__ + "static/media/shannon-airport.9296e509.png";